import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { LogIn, LogOut, LayoutDashboard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function AdminBar() {
  const { isAuthenticated, loading, login, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex gap-2">
        {isAuthenticated ? (
          <>
            <button
              onClick={() => navigate('/admin')}
              className="bg-orange-500 text-white p-2 rounded-full shadow-lg hover:bg-orange-600 transition-colors"
              title="Administration"
            >
              <LayoutDashboard className="w-5 h-5" />
            </button>
            <button
              onClick={logout}
              className="bg-gray-500 text-white p-2 rounded-full shadow-lg hover:bg-gray-600 transition-colors"
              title="Déconnexion"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </>
        ) : (
          <button
            onClick={login}
            disabled={loading}
            className={`bg-orange-500 text-white p-2 rounded-full shadow-lg transition-colors ${
              loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-orange-600'
            }`}
            title="Connexion administrateur"
          >
            <LogIn className="w-5 h-5" />
          </button>
        )}
    </div>
  );
}